
namespace RioERP.Orders {
    export class OrderPaymentColumns {
        static columnsKey = 'Orders.OrderPayment';
    }
}